import React, { useEffect } from "react";
import Cta from "../../../components/cta/Cta";
import "./style.scss";

export default function HomePage(props) {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    window.dataLayer?.push({
      event: "mtcExpScreen",
      screen: "Home",
      step: 1,
    });
    if (window.hj) {
      window.hj("stateChange", "2");
    }
  }, []);

  return (
    <div className="home-container mv-xl">
      <div className="home-screen">
        <div className="home-screen-wrap fade-in">
          <h1
            className="headline--primary mv-50 text-uppercase"
            aria-label={`${props.productName1} ${props.productName2} ${props.productName3}`}
          >
            <span>{props.productName1}</span>
            <span>{props.productName2}</span>
            <span>{props.productName3}</span>
          </h1>
        </div>
      </div>
      <div className="flex-center action-bar">
        <Cta path="/intro" ctaClass="cta--primary cta--centered">
          {props.btnTitle}
        </Cta>
      </div>
    </div>
  );
}
